var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.component,_vm._g({tag:"Component",attrs:{"libType":_vm.libType,"model":_vm.model,"specData":_vm.specData,"isFromPopup":_vm.isFromPopup,"formModel":_vm.formModel,"colSize":_vm.colSize,"from":_vm.from}},_vm.$listeners))}
var staticRenderFns = []

export { render, staticRenderFns }